import { AfterViewInit, Component, ElementRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { initFluid } from '@modules/cursors/components/fluid-cursor/init-fluid';

@Component({
  selector: 'app-fluid-cursor',
  template: `
    <canvas id="fluid" #canvasElement></canvas>`,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
})
export class FluidCursorComponent implements AfterViewInit {
  @ViewChild('canvasElement') canvasElement: ElementRef<HTMLCanvasElement>;
  canvas: HTMLCanvasElement;

  ngAfterViewInit() {
    this.initFluidCursor();
  }

  initFluidCursor() {
    this.canvas = this.canvasElement.nativeElement;
    initFluid(this.canvas);
  }
}
